@if (config$ | async; as config) {
  <rms-base-layout>
    <rms-account-lock-banner />
    <vex-progress-bar />
    <rms-search />
    <mat-sidenav-container
      class="vex-layout-sidenav-container"
      [class.vex-layout-sidenav-container--with-banner]="isLocked$ | async">
      <mat-sidenav
        (closedStart)="onSidenavClosed()"
        [disableClose]="!!(sidenavDisableClose$ | async)"
        [fixedInViewport]="!!(sidenavFixedInViewport$ | async)"
        [mode]="(sidenavMode$ | async) ?? 'side'"
        [opened]="!!(sidenavOpen$ | async)">
        <rms-sidenav [collapsed]="!!(sidenavCollapsed$ | async)" />
      </mat-sidenav>
      <mat-sidenav
        (closedStart)="onQuickpanelClosed()"
        [opened]="!!(quickpanelOpen$ | async)"
        class="vex-layout-quickpanel"
        mode="over"
        position="end">
        <rms-quickpanel />
      </mat-sidenav>
      <mat-sidenav-content class="vex-layout-sidenav-content">
        @if (sidenavFixedInViewport$ | async) {
          <rms-toolbar
            [class.dark]="config.layout === 'vertical'"
            class="vex-toolbar" />
        }
        <main class="vex-layout-content">
          <router-outlet />
        </main>
        @if (config.footer.visible) {
          <rms-footer class="vex-footer" />
        }
      </mat-sidenav-content>
    </mat-sidenav-container>
    <!--TODO we will add it when we implement it's logic
    <rms-config-panel-toggle
    (openConfig)="configpanel.open()"></rms-config-panel-toggle>-->
    <!-- CONFIGPANEL -->
    <vex-sidebar
      #configpanel
      [invisibleBackdrop]="true"
      [opened]="!!(configPanelOpen$ | async)"
      position="right">
      <rms-config-panel />
    </vex-sidebar>
    <!-- END CONFIGPANEL -->
  </rms-base-layout>
}
